import { createLocalCartUuidStore } from '@iheartjane/menu';
import type { AppMode } from '@iheartjane/types';
import { Storage } from '@iheartjane/utils';

import { cartStorageKey } from '@jane/monolith/customer/redux/cart';

/**
 * Adoption read: pre-flip bags exist only as Redux's persisted cart, so without
 * this `c3UseV3Cart` empties every one. Cart-less it holds `uuid: ''` → absent.
 *
 * TODO(carts-v3): delete with the Redux slice at slot 017, and `storeId` with it.
 */
const legacyStoredCartUuid = (appMode: AppMode, storeId?: string | number) =>
  Storage.get<{ uuid?: string }>(cartStorageKey(appMode, storeId))?.uuid ||
  null;

// No `legacyClear`: nothing writes the uuid key until 015, and the Redux persist
// subscriber still owns the legacy cart, so a clear here would be undone anyway.
const { getLocalCartUuid, updateLocalCartUuid, useLocalCartUuid } =
  createLocalCartUuidStore({ legacyRead: legacyStoredCartUuid });

export { getLocalCartUuid, updateLocalCartUuid, useLocalCartUuid };
